// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__49qgc {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
}

@media (max-width: 1400px) {
  .styles_img__6XW-A {
    width: 600px;
  }
}
@media (max-width: 1200px) {
  .styles_img__6XW-A {
    width: 400px;
  }
}
@media (max-width: 1200px) {
  .styles_img__6XW-A {
    width: 330px;
  }
}

.styles_headingBlock__AZBx0 {
  padding: 0 190px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 1700px) {
  .styles_headingBlock__AZBx0 {
    padding: 0 60px;
  }
}
@media (max-width: 1200px) {
  .styles_headingBlock__AZBx0 {
    padding: 0 30px;
  }
}
@media (max-width: 992px) {
  .styles_headingBlock__AZBx0 {
    padding: 0 15px;
    flex-direction: column-reverse;
    justify-content: center;
    gap: 32px;
  }
}

.styles_heading__z8bnl {
  font-weight: 800;
  font-size: 50px;
  line-height: 62px;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  color: #ffffff;
}
@media (max-width: 992px) {
  .styles_heading__z8bnl {
    font-size: 24px;
    line-height: 30px;
  }
}

.styles_text__cC5IZ {
  font-weight: 300;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.8);
}
@media (max-width: 992px) {
  .styles_text__cC5IZ {
    font-size: 18px;
    line-height: 22px;
  }
}

.styles_textWrapper__kFfNh {
  width: 330px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styles_btnBlock__s19RA {
  display: none;
  height: 100%;
  width: 100%;
  padding: 32px 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
}
@media (max-width: 992px) {
  .styles_btnBlock__s19RA {
    display: flex;
  }
}

.styles_btnWrapper__4BbhF {
  width: 330px;
  height: 60px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/main/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAFF;;ACME;EDDF;IAEI,YAAA;EAFF;AACF;ACME;EDPF;IAMI,YAAA;EADF;AACF;ACCE;EDPF;IAUI,YAAA;EAAF;AACF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAF;ACvBE;EDmBF;IAOI,eAAA;EACF;AACF;AChBE;EDOF;IAWI,eAAA;EAEF;AACF;ACfE;EDCF;IAeI,eAAA;IACA,8BAAA;IACA,uBAAA;IACA,SAAA;EAGF;AACF;;AAAA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,cEtDM;AFyDR;AChCE;EDuBF;IASI,eAAA;IACA,iBAAA;EAIF;AACF;;AADA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BE3DS;AF+DX;AC9CE;EDqCF;IAQI,eAAA;IACA,iBAAA;EAKF;AACF;;AAFA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAKF;;AAFA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAKF;ACtEE;EDyDF;IAWI,aAAA;EAMF;AACF;;AAHA;EACE,YAAA;EACA,YAAA;AAMF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-grow: 1;\n}\n\n.img {\n  @include xxl {\n    width: 600px;\n  }\n\n  @include xl {\n    width: 400px;\n  }\n\n  @include xl {\n    width: 330px;\n  }\n}\n\n.headingBlock {\n  padding: 0 190px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  @include xxxl {\n    padding: 0 60px;\n  }\n\n  @include xl {\n    padding: 0 30px;\n  }\n\n  @include lg {\n    padding: 0 15px;\n    flex-direction: column-reverse;\n    justify-content: center;\n    gap: 32px;\n  }\n}\n\n.heading {\n  font-weight: 800;\n  font-size: 50px;\n  line-height: 62px;\n  letter-spacing: -0.015em;\n  text-transform: uppercase;\n  color: $white;\n\n  @include lg {\n    font-size: 24px;\n    line-height: 30px;\n  }\n}\n\n.text {\n  font-weight: 300;\n  font-size: 24px;\n  line-height: 30px;\n  letter-spacing: -0.015em;\n  color: $white-80;\n\n  @include lg {\n    font-size: 18px;\n    line-height: 22px;\n  }\n}\n\n.textWrapper {\n  width: 330px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.btnBlock {\n  display: none;\n  height: 100%;\n  width: 100%;\n  padding: 32px 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 32px;\n\n  @include lg {\n    display: flex;\n  }\n}\n\n.btnWrapper {\n  width: 330px;\n  height: 60px;\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__49qgc`,
	"img": `styles_img__6XW-A`,
	"headingBlock": `styles_headingBlock__AZBx0`,
	"heading": `styles_heading__z8bnl`,
	"text": `styles_text__cC5IZ`,
	"textWrapper": `styles_textWrapper__kFfNh`,
	"btnBlock": `styles_btnBlock__s19RA`,
	"btnWrapper": `styles_btnWrapper__4BbhF`
};
export default ___CSS_LOADER_EXPORT___;
